import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Button.scss';

const Button = ({ variantClasses = [], text, type, location, href, id = false, disabled = false, clickEventHandler = () => {}, mouseEnterEventHandler, mouseLeaveEventHandler, style, ...props }) => {
	const attrs = {};
	let classes = [s.button];
	if (variantClasses) classes = [...classes, ...(Array.isArray(variantClasses) ? variantClasses.map((c) => s[c]) : [s[variantClasses.toString()]])];
	const innerContent = text || props.children;

	if (type === 'link' && !location) return <span {...props} className={classes.join(' ')}>{ innerContent }</span> || null;

	const link = cleanInternalLinks(location);
	const externalLink = /^(https?|mailto|tel)/.test(link);
	const anchorLink = /^#/.test(link);

	if (type === 'a' || (type === 'link' && externalLink) || (type === 'link' && anchorLink)) {
		const attrs = {};
		if (href) attrs.href = href;
		if (!attrs.href && link) attrs.href = link;
		if (externalLink) {
			attrs.rel = 'noreferrer noopener';
			attrs.target = '_blank';
		}
		return <a className={classes.join(' ')} {...attrs} onClick={(e) => clickEventHandler(e)} style={style}>{ innerContent }</a>; // eslint-disable-line
	}
	if (type === 'link') {
		return <Link {...props} className={classes.join(' ')} to={link} onClick={(e) => clickEventHandler(e)} style={style}>{ innerContent }</Link>;
	}
	// eslint-disable-next-line react/button-has-type
	return <button {...props} className={classes.join(' ')} disabled={disabled} type={type} onClick={clickEventHandler} onMouseEnter={mouseEnterEventHandler} onMouseLeave={mouseLeaveEventHandler} style={style}>{ innerContent }</button>;
};

export default hot(module)(Button);
